import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Save } from "lucide-react";
import Field from "./Field";

const FIELDS = [
  { name: "name", label: "Name", required: true },
  { name: "title", label: "Title", required: true },
  { name: "tagline", label: "Tagline", type: "textarea" },
  { name: "bio", label: "Bio", type: "textarea", required: true },
  { name: "hero_headline", label: "Hero Headline" },
  { name: "hero_subline", label: "Hero Subline" },
  { name: "years_experience", label: "Years Experience", type: "number" },
  { name: "location", label: "Location" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  { name: "github", label: "GitHub URL" },
  { name: "linkedin", label: "LinkedIn URL" },
  { name: "twitter", label: "Twitter URL" },
  { name: "website", label: "Website" },
  { name: "avatar_url", label: "Avatar URL", type: "image" }
];

export default function ProfileEditor() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/profile").then((r) => setForm(r.data || {})).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      await api.put("/profile", form);
      toast.success("Profile saved.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Save failed");
    }
  };

  if (loading) return <p className="text-fog-300">Loading…</p>;
  return (
    <div data-testid="admin-profile-editor">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display font-bold text-2xl">Profile</h2>
        <button onClick={save} className="btn-volt" data-testid="admin-profile-save"><Save className="w-4 h-4" /> Save</button>
      </div>
      <div className="grid md:grid-cols-2 gap-5 card-tech p-5">
        {FIELDS.map((f) => (
          <div key={f.name} className={f.type === "textarea" ? "md:col-span-2" : ""}>
            <Field field={f} value={form[f.name]} onChange={(v) => setForm({ ...form, [f.name]: v })} />
          </div>
        ))}
      </div>
    </div>
  );
}
